import React, { Fragment, useContext } from 'react';
import NotificationsGrid from './NotificationsGrid';
import { LoginContext } from '../../contexts/LoginContext';
import { Button, makeStyles, TextField, Tooltip } from '@material-ui/core';
import { AddBox } from '@material-ui/icons';
import NotificationDetailsModal from './NotificationDetailsModal/NotificationDetailsModal';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { commonActionHeader, commonFilter } from '../../constants/StyleConstants';
import CustomDatePicker from '../../components/UI/CustomDatePicker';
import { tooltipDelay } from '../../utils/GridUtils';
import AreaSelect from '../../components/AreaSelect';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';
import useNotificationsPresenter from './NotificationsPresenter';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
  ...commonActionHeader(theme),
  formControl: {
    minWidth: 120,
  },
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { area, setArea, title, setTitle, dateFrom, setDateFrom, dateTo, setDateTo, validateAndSearch, cleanFilters } = filtersProps;

  return (
    <div className={classes.filters}>
      <AreaSelect style={{ marginBottom: 4 }} value={area} setValue={setArea} />
      <TextField
        margin="dense"
        id="notificationTitleField"
        style={{ width: 300 }}
        label="Título"
        onChange={e => setTitle(e.target.value)}
        value={title}
      />
      <CustomDatePicker value={dateFrom} maxDate={dateTo} setValue={setDateFrom} label="Fecha desde" />
      <CustomDatePicker value={dateTo} minDate={dateFrom} setValue={setDateTo} label="Fecha hasta" />
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Tooltip title={'Limpiar filtros'} enterDelay={tooltipDelay} enterNextDelay={tooltipDelay}>
          <Button variant="outlined" color="secondary" onClick={cleanFilters}>
            Limpiar
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

const Notifications = () => {
  const classes = useStyles();
  const { isSupplier, isVisibleByRole } = useContext(LoginContext);

  const { open, setOpen, rows, setRows, firstLoad, loading, search, ...filtersProps } = useNotificationsPresenter(isSupplier);

  return (
    <Fragment>
      <NotificationDetailsModal open={open} setOpen={setOpen} reloadGrid={search} />
      {!isSupplier ? (
        <>
          <div className={classes.actionHeader}>
            {isVisibleByRole && (
              <div>
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.actionHeaderButton}
                  startIcon={<AddBox />}
                  onClick={() => setOpen(true)}>
                  Nueva notificación
                </Button>
              </div>
            )}
          </div>
          <Filters filtersProps={filtersProps} />
        </>
      ) : (
        // Separación para no dejar la grilla pegada al rotulo de la funcionalidad
        <div style={{ marginTop: '1em' }}></div>
      )}

      <ViewPortGridWrapper>
        <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
          <NotificationsGrid data={rows} loading={loading} reloadGrid={search} />
        </DefaultUnrederedGridMessage>
      </ViewPortGridWrapper>
    </Fragment>
  );
};

export default Notifications;
